'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _ChangePassword = require('./ChangePassword.scss');var styles = _interopRequireWildcard(_ChangePassword);


var _components = require('../../../components');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Styles
// Components
var ChangePassword = function (_Component) {_inherits(ChangePassword, _Component);function ChangePassword() {var _temp, _this, _ret;_classCallCheck(this, ChangePassword);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      currentPasswordIsValid: false,
      newPasswordIsValid: false,
      showTooltipCurrentPassword: false,
      showTooltipNewPassword: false,
      currentPasswordFieldIsDirty: false,
      newPasswordFieldIsDirty: false,
      tooltipMessage: '' + _this.props.translate('tooltipMessage', 'passwordTooltipLengthMessage') }, _this.


    handleSubmit = function (event) {
      var currentPassword = event.target.current_password.value;
      var newPassword = event.target.new_password.value;
      event.preventDefault();
      _this.setState({
        currentPasswordFieldIsDirty: true,
        newPasswordFieldIsDirty: true });


      if (currentPassword.length === 0) {
        _this.setState({
          tooltipMessage: '' + _this.props.translate('tooltipMessage', 'enterOldPassword'),
          showTooltipCurrentPassword: true,
          showTooltipNewPassword: false,
          currentPasswordIsValid: false,
          newPasswordIsValid: false });

        event.target.current_password.classList.add('not_valid');
        if (newPassword.length === 0) {
          event.target.new_password.classList.add('not_valid');
        }
      } else if (currentPassword.length < 6 || currentPassword.length > 20) {
        _this.setState({
          tooltipMessage: '' + _this.props.translate('tooltipMessage', 'passwordTooltipLengthMessage'),
          showTooltipCurrentPassword: true,
          showTooltipNewPassword: false,
          currentPasswordIsValid: false,
          newPasswordIsValid: false });

        event.target.current_password.classList.add('not_valid');
      } else if (newPassword.length === 0) {
        _this.setState({
          tooltipMessage: '' + _this.props.translate('tooltipMessage', 'enterNewPassword'),
          showTooltipNewPassword: true,
          showTooltipCurrentPassword: false,
          currentPasswordIsValid: true,
          newPasswordIsValid: false });

        event.target.new_password.classList.add('not_valid');
      } else if (currentPassword === newPassword) {
        _this.setState({
          tooltipMessage: '' + _this.props.translate('tooltipMessage', 'passwordsShouldNotBeTheSame'),
          showTooltipNewPassword: true,
          showTooltipCurrentPassword: false,
          currentPasswordIsValid: true,
          newPasswordIsValid: false });

        event.target.new_password.classList.add('not_valid');
      } else if (newPassword.length < 6 || newPassword.length > 20) {
        _this.setState({
          tooltipMessage: '' + _this.props.translate('tooltipMessage', 'passwordTooltipLengthMessage'),
          showTooltipNewPassword: true,
          showTooltipCurrentPassword: false,
          currentPasswordIsValid: true,
          newPasswordIsValid: false });

        event.target.new_password.classList.add('not_valid');
      } else {
        _this.setState({
          showTooltipCurrentPassword: false,
          showTooltipNewPassword: false,
          currentPasswordIsValid: true,
          newPasswordIsValid: true });

        _this.props.changePassword({
          access_token: _this.props.access_token,
          current_password: currentPassword,
          new_password: newPassword });

      }
    }, _temp), _possibleConstructorReturn(_this, _ret);}ChangePassword.prototype.

  render = function render() {var _this2 = this;
    return (
      _react2.default.createElement('div', { className: styles.changePassword },
        _react2.default.createElement('div', null, _react2.default.createElement('span', { className: styles.title }, this.props.translate('changePassword'))),
        _react2.default.createElement('form', {
            onKeyDown: function onKeyDown(event) {return _this2.props.triggerPressEnter(event.keyCode, _this2.submit);},
            onSubmit: this.handleSubmit },

          _react2.default.createElement('div', { ref: function ref(currentPassword) {_this2.currentPassword = currentPassword;} },
            _react2.default.createElement(_components.OMInputField, {
              name: 'current_password',
              type: 'password',
              placeholder: '' + this.props.translate('currentPassword'),
              title: '' + this.props.translate('currentPasswordTitle'),
              showHoverTooltip: this.state.showTooltipCurrentPassword && this.state.currentPasswordFieldIsDirty,
              isInvalid: this.state.showTooltipCurrentPassword,
              tooltipMessage: this.state.tooltipMessage,
              fieldIsDirty: function fieldIsDirty(isDirty) {return _this2.setState({ currentPasswordFieldIsDirty: isDirty });},
              validate: this.props.validatePassword,
              isMobile: this.props.isMobile,
              hidePasswordTitle: '' + this.props.translate('hidePassword'),
              revealPasswordTitle: '' + this.props.translate('revealPassword'),
              isRtl: this.props.isRtl })),


          _react2.default.createElement('div', { ref: function ref(newPassword) {_this2.newPassword = newPassword;} },
            _react2.default.createElement(_components.OMInputField, {
              name: 'new_password',
              type: 'password',
              placeholder: '' + this.props.translate('newPassword'),
              title: '' + this.props.translate('newPasswordTitle'),
              showHoverTooltip: this.state.showTooltipNewPassword && this.state.newPasswordFieldIsDirty,
              isInvalid: this.state.showTooltipNewPassword,
              tooltipMessage: this.state.tooltipMessage,
              fieldIsDirty: function fieldIsDirty(isDirty) {return _this2.setState({ newPasswordFieldIsDirty: isDirty });},
              validate: this.props.validatePassword,
              isMobile: this.props.isMobile,
              hidePasswordTitle: '' + this.props.translate('hidePassword'),
              revealPasswordTitle: '' + this.props.translate('revealPassword'),
              isRtl: this.props.isRtl })),


          _react2.default.createElement('div', { className: styles.authorization_buttons },
            _react2.default.createElement('button', { ref: function ref(submit) {_this2.submit = submit;}, className: 'btn btn-primary', type: 'submit', disabled: this.props.loading },
              this.props.loading ?
              _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', styles.spinner) }) : '' +
              this.props.translate('submit'))))));





  };return ChangePassword;}(_react.Component);


ChangePassword.propTypes = {
  isMobile: _propTypes2.default.bool.isRequired,
  translate: _propTypes2.default.func,
  changePassword: _propTypes2.default.func,
  validatePassword: _propTypes2.default.func,
  triggerPressEnter: _propTypes2.default.func,
  access_token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool };exports.default =


ChangePassword;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UserAuthentication/ChangePassword/ChangePassword.js
// module id = 2879
// module chunks = 0